/* src/app/components/discovery/dialogs/download-production-withheld-dialog/download-production-withheld-dialog.component.scss */
mat-dialog-content {
  margin: 24px;
  min-width: 375px;
  min-height: 100px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*# sourceMappingURL=download-production-withheld-dialog.component.css.map */
